import { Input } from 'reactstrap';
import { handleCheckboxChange } from './ModifyAddPartnerFunctions';
import { formatDateForDisplay,formatCellValue} from '../../Utils/UtilityFunctions';
export const partnerListInsidePolicy = (organizationsWithMaidIds,organizationsWithPhoneNum,formattedOrganizations,setSelectedPartners,selectedPartners,allData,setSelectedOnes) => {
    const columns = [
        {
            accessorKey: ' ',
            header: '',
            enableColumnActions: false,
            enableColumnDragging: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            Cell: ({ row }) => (
                <Input type="checkbox" className=' border-black fs-5' checked={selectedPartners.some(p => p.extractedId === row.original.extractedId)} onChange={() => {handleCheckboxChange(row, selectedPartners, setSelectedPartners,setSelectedOnes)}} style={{ borderWidth: '2px', borderColor: '#000', borderRadius: '0' }} />
            ),
            size:60
        },
        {
            accessorKey: 'extractedId',
            header: 'Partner ID',
             Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
        {
            accessorKey: 'tradingName',
            header: 'Business Name',
            Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
        {
            accessorKey: 'organizationType',
            header: 'Type',
            Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
        {
            accessorFn: (PartnerData, index) => `${organizationsWithMaidIds[index].maidIds}`,
            header: 'Email',
             Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
        {
            accessorFn: (PartnerData, index) => `${organizationsWithPhoneNum[index].PhoneNums}`,
            header: 'Phone',
             Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
        {
            accessorFn: (PartnerData, index) => `${formattedOrganizations[index].createdAt}`,
            header: 'Created On',
             Cell: ({ cell }) => formatCellValue(cell.getValue(),val=> formatDateForDisplay(val))
        },
    ]
    return columns
}